var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudIndex',{attrs:{"permission":_vm.PERMISSION_CODES.VIEW_CCTV_MASTER,"title":"CCTV Masters","viewColumns":_vm.columns,"fetchUrl":"/cctv-masters","createUrl":"/cctv-masters","updateRootUrl":"/cctv-masters","deleteRootUrl":"/cctv-masters","createFields":_vm.createFields,"reloadOnSuccess":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }